<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Solicitações</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                  <label for>Unidade solicitante</label>
                  <select-unidade
                    @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadeSolicitante(unidadeSelecionada);
                                            }
                                        "
                  ></select-unidade>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <label for>Procedimento</label>
                  <select-procedimento
                    @setProcedimentoSelecionado="
                                            procedimentoSelecionado => {
                                                setProcedimentoSelecionado(procedimentoSelecionado);
                                            }
                                        "
                  ></select-procedimento>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for>Competência</label>
                  <select v-model="filtros.distribuicao_id" class="form-control" name id>
                    <option
                      v-for="(item, index) in distribuicoes"
                      :key="index"
                      :value="item.id"
                    >{{ item.data_competencia | competencia }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.MARCADA"
                  />Marcada
                </label>
                <div v-if="this.$store.state.user.nivel == 'administrador'">
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.EM_REGULACAO"
                  />Em regulação
                </label> 
                  <label class="checkbox-inline">
                    <input
                      v-model="filtros.situacoes"
                      type="checkbox"
                      :value="SITUACAO_SOLICITACAO.REGULADA"
                    />Regulada
                  </label>
                  <label class="checkbox-inline">
                    <input
                      v-model="filtros.situacoes"
                      type="checkbox"
                      :value="SITUACAO_SOLICITACAO.NEGATIVADA"
                    />Negativada
                  </label>
                  <label class="checkbox-inline">
                    <input
                      v-model="filtros.situacoes"
                      type="checkbox"
                      :value="SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE"
                    />Informação pendente
                  </label>
                  <label class="checkbox-inline">
                    <input
                      v-model="filtros.situacoes"
                      type="checkbox"
                      :value="SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL"
                    />Informação adicional
                  </label>
                </div>
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.CONFIRMADA"
                  />Confirmada
                </label>
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.CANCELADA"
                  />Cancelada
                </label>
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.FALTA"
                  />Falta
                </label>
                <label class="checkbox-inline">
                  <input
                    v-model="filtros.situacoes"
                    type="checkbox"
                    :value="SITUACAO_SOLICITACAO.REALIZADA"
                  />Realizada
                </label>
              </div>
            </div>
            <div class="row" ref="filtrar">
              <div class="col-sm-12">
                <button
                  :disabled="!finalizado"
                  @click="getDataTable()"
                  data-toggle="tooltip"
                  title="Pesquisar Relatório de Solicitação"
                  id="resultado"
                  class="btn btn-primary pull-right"
                >
                  <i class="fa fa-search"></i> Pesquisar
                </button>
              </div>
            </div>
            <br />
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Unidade solicitante</th>
                  <th>Procedimento</th>
                  <th>Quantidade solicitada</th>
                  <th>Mês/Ano</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dataTable" :key="index">
                  <td>{{ item.unidade }}</td>
                  <td>{{ item.procedimento }}</td>
                  <td>{{ item.quantidade }}</td>
                  <td>{{ item.competencia | competencia }}</td>
                </tr>
              </tbody>
            </table>
            <!--
            <div class="row">
              <div
                class="col-sm-4"
              >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
              <div class="col-sm-8" style="text-align:right">
                <laravue-pagination
                  :limit="7"
                  :data="dataTable"
                  v-on:pagination-change-page="getDataTable"
                >
                  <span slot="prev-nav">&lt; Anterior</span>
                  <span slot="next-nav">Próximo &gt;</span>
                </laravue-pagination>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
import axios from "axios"; // Cliente para requisição http
import { SITUACAO_SOLICITACAO } from "@/constants";

export default {
  components: {
    selectUnidade,
    selectProcedimento
  },
  computed: {
    SITUACAO_SOLICITACAO: function() {
      return SITUACAO_SOLICITACAO;
    }
  },
  data: () => ({
    filtros: {
      distribuicao_id: null,
      unidade_id: "",
      procedimento_id: "",
      situacoes: [
        SITUACAO_SOLICITACAO.MARCADA,
        SITUACAO_SOLICITACAO.EM_REGULACAO,
        SITUACAO_SOLICITACAO.REGULADA,
        SITUACAO_SOLICITACAO.NEGATIVADA,
        SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
        SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
        SITUACAO_SOLICITACAO.CONFIRMADA,
        SITUACAO_SOLICITACAO.CANCELADA,
        SITUACAO_SOLICITACAO.FALTA,
        SITUACAO_SOLICITACAO.REALIZADA
      ]
    },
    dataTable: {},
    finalizado: true,
    distribuicoes: []
  }),
  mounted() {
    this.getDistribuicoes();
    if (this.$store.state.user.nivel == "prestador") {
      this.filtros.situacoes = [
        SITUACAO_SOLICITACAO.MARCADA,
        SITUACAO_SOLICITACAO.CONFIRMADA,
        SITUACAO_SOLICITACAO.CANCELADA,
        SITUACAO_SOLICITACAO.FALTA,
        SITUACAO_SOLICITACAO.REALIZADA
      ];
    }
  },
  methods: {
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      this.finalizado = false;

      axios
        .get(
          `${this.$store.state.serverURI}/api/relatorios/solicitacao-sintetico`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
          this.finalizado = true;
        })
        .catch(error => {
          console.log(error);
          this.finalizado = true;
        });
    },
    setUnidadeSolicitante(unidadeSolicitante) {
      this.filtros.unidade_id = unidadeSolicitante.id;
    },
    setProcedimentoSelecionado(procedimentoSelecionado) {
      this.filtros.procedimento_id = procedimentoSelecionado.id;
    },
    getDistribuicoes() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAll`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.distribuicoes = response.data;
          this.filtros.distribuicao_id = this.distribuicoes[0].id;
          this.getDataTable();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?934f619c